import { render, staticRenderFns } from "./HoUserAllocationListTable.vue?vue&type=template&id=02b97de8&scoped=true"
import script from "./HoUserAllocationListTable.vue?vue&type=script&lang=js"
export * from "./HoUserAllocationListTable.vue?vue&type=script&lang=js"
import style0 from "./HoUserAllocationListTable.vue?vue&type=style&index=0&id=02b97de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b97de8",
  null
  
)

/* custom blocks */
import block0 from "./HoUserAllocationListTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports